export default __webpack_public_path__ + "static/media/left-white.8482e1a4.svg";